import { Reducer } from 'redux';
import { IModule } from 'redux-dynamic-modules';

import { ProfileState } from './ProfileState';
import { StateProfileReducer } from './reducer';

export const getProfileModule = (): IModule<{ Profile: ProfileState }> => ({
  id: 'Profile',
  reducerMap: {
    Profile: StateProfileReducer as Reducer,
  },
  initialActions: [],
  finalActions: [],
});
